import { createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = {
  xmlns: "http://www.w3.org/2000/svg",
  fill: "none",
  viewBox: "0 0 16 24"
}

export function render(_ctx, _cache) {
  return (_openBlock(), _createElementBlock("svg", _hoisted_1, [...(_cache[0] || (_cache[0] = [
    _createElementVNode("path", {
      fill: "currentColor",
      d: "M16 7.82C16 3.519 12.4 0 8 0S0 3.518 0 7.82c0 2.542 1.2 4.79 3.1 6.159L2 22.386c-.1.39.1.782.4.977.3.196.7.196 1.1 0L8 20.724l4.5 2.64c.1.097.3.097.5.097s.4-.098.5-.195c.1-.098.5-.587.4-.978l-1.1-8.31c2-1.368 3.2-3.616 3.2-6.158m-14 0c0-3.226 2.7-5.866 6-5.866s6 2.64 6 5.866-2.7 5.865-6 5.865-6-2.64-6-5.865m9.7 12.806-3.2-1.857a.93.93 0 0 0-1 0l-3.2 1.857.7-5.572q1.35.587 3 .587t3-.587z"
    }, null, -1)
  ]))]))
}
export default { render: render }